import React, { Component, createRef } from 'react';
import { Box } from '@mui/material';

import { tuples, ucfirst, clone } from '../../core/utils';
import { formatDate, formatStatus, formatState, formatSource } from '../../components/renderers';

import { setConfig } from '../../core';
import { ProgressDialog } from '../../components/dialogs';
import { ServiceWindow } from '../../components/service';
import { pages as custompages} from '../custom';
import { DirectBudgetWorkbench as MainPanel} from '../custom/directbudget';

const s:any ={
  root: {
    width: '100%',
  },
  titlebar: {
    padding:0,
    backgroundColor: 'success.light',
  },
  details: {
    alignItems: 'center',
    p: 1,

  },
};



class DirectBudget extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;

  form = createRef();
  constructor(props:any) {
    super(props);
    this.state = {
      url: '/api/kpis',
      params: {s:'objectivecontract'},
      action: '',
      actions: [],
      filter: {},
      loading: false,
      wizmode: 'add',
      record: {},
      data: [],
      recordCount: 0,
      page: 0,
      rowsPerPage: 10,
      pageMode: 'local',
      order: 'desc',
      orderBy: 'dcd',
      refid: null,
      
      conf: {},
      views:[],
      count:0,
      open: false,
      valid: false,
      loadcolor: 'inherit',
      datasets: null,
      dataset: null
    };
  }

  configuration = () => {
    const config = {
      service:{
        name:'requisition',
        title:'Requisition',
        fields:['rid','fnm','mnm','lnm','nam','gdi','mbn','dcd','aci','acn','acc','bci','coi','coy','cos',
                'ano','anm','cui','cuy','cus','bri','bnm','bcd','iti','itn','itc','idn','idy','tel','knm',
                'krn','kcn','rmk','sts','ast','stp'],
        grid: [['dcd','Date'],['nam','Name'],['gdi','Gender'],['acn','Account'],['bnm','Branch'],['bci','Reference'],['mbn','Mobile'],['idy','ID'],
              ['coy','Country'],['sts','Status'],['stp','Stamp']],
        menu: {mnu:[{t:'Customer',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
        eform:[
          {id:'fnm',label:'Firstname',type:'tf',req:1,col:1,ops:{}},
          {id:'mnm',label:'Middlename',type:'tf',req:0,col:1,ops:{}},
          {id:'lnm',label:'Lastname',type:'ta',req:0,col:1,ops:{}},
          {id:'gdi',label:'Gender',type:'fa',req:0,col:1,ops:{},cp:{t:'lcs',s:'gender'}},
          {id:'mbn',label:'Mobile',type:'tf',req:0,col:1,ops:{type:'tel'}},
          {id:'aci',label:'Service',type:'fa',req:1,col:1,ops:{},cp:{t:'bcs',s:'idtype'}},
          {id:'bci',label:'ServiceID',type:'tf',req:0,col:1,ops:{type:'tel'}},
          {id:'coi',label:'Country',type:'fa',req:1,col:1,ops:{},cp:{t:'bcs',s:'idtype'}},
          {id:'iti',label:'ID Type',type:'fa',req:1,col:1,ops:{},cp:{t:'bcs',s:'idtype'}},
          {id:'idn',label:'ID No',type:'tf',req:0,col:1,ops:{} },
          {id:'cui',label:'Currency',type:'fa',req:1,col:1,ops:{},cp:{t:'bcs',s:'idtype'}},
          {id:'bri',label:'Branch',type:'fa',req:1,col:1,ops:{},cp:{t:'bcs',s:'idtype'}},
          {id:'ano',label:'Account No',type:'tf',req:0,col:1,ops:{type:'tel'}},
          {id:'anm',label:'Account Name',type:'tf',req:0,col:1,ops:{type:'tel'}},
          {id:'ctn',label:'Contact',type:'tf',req:0,col:1,ops:{type:'tel'}},
          {id:'knm',label:'Kin Name',type:'tf',req:0,col:1,ops:{type:'tel'}},
          {id:'kre',label:'Kin Relation',type:'tf',req:0,col:1,ops:{}},
          {id:'kco',label:'Kin Contact',type:'tf',req:0,col:1,ops:{type:'tel'}},
          {id:'rmk',label:'Remarks',type:'ta',req:0,col:1,ops:{}},
          {id:'sts',label:'Status',type:'fa',req:0,col:1,ops:{},cp:{t:'lcs',s:'status'}},
        ],
      },
      fw:true,
      create:true,
      actions: {add:'Add',generate:'Generate',edit:'Edit',view:'View',review:'Review',process:'Process',analyze:'Analyze',reset:'Reset'},
      panels: {add:'custom',generate:'custom',edit:'custom',view:'custom',review:'custom',process:'custom',analyze:'custom',reset:'custom'},
    };
    return config;
  }

  startLoading = () => {
    this.setState({loading:true});
  }

  stopLoading = () => {
    this.setState({loading:false});
  }

  onExpChange = (event:any,expanded:boolean) => {
    if (!expanded) this.setState({open:false})
  }

  onClose = (event:any) => {
    this.setState({open:false})
  }

  onResponse = (status: any, response: any) => {
    if (status) {
      this.onClose(response);
    }
  };

  onNavigate = (action: string,record:any={}) => {
    if(custompages.requisition && custompages.requisition[action]){
      this.setState({action,open:true,record});
    }
  }

  render = () => {
    const {
      code,
      title,
      service,
      configuration,
      actionSet,
      onSubmit,
      showNotification,
      classes,
      ...others
    } = this.props;
    const { formformatters, onChange } = this.props;
    const { url,action,loading,wizmode,open,record,data,} = this.state;

    const conf = configuration||this.configuration;
    const customconfig = Object.assign({}, conf()||{});
    const config = setConfig(customconfig); 

    const ServiceConfig = clone(config);
    const SData = ServiceConfig.service;
    if (!SData) this.props.setHome();
    const stitle = ucfirst(SData.title || service);
    const panels = ServiceConfig.panels;

    const Columns = tuples(SData.grid);
    if (Columns.length > 0) Columns.push({ k: 'ACTION', v: '' });
    //console.log('tuples',Columns,Columns.length);
    const cm = SData.cols;
    const fmformatters = {
      ste: formatState('form'),
      sts: formatStatus,
      dcd: formatDate,
      stp: formatDate,
      src: formatSource,
    };

    //add formatters from config and from class to base formatters
    const cformatters = ServiceConfig.formatters || {};
    const { form: cfformatters, grid: cgformatters } = cformatters;
    const _formformatters = Object.assign(
      {},
      fmformatters,
      cfformatters,
      formformatters || {}
    );
    const isform = action !== '';
    console.log('action',':',action,',',wizmode,',',isform);

    return (
      <Box>
        {isform && open && (
          <ServiceWindow
            open={open}
            mode={wizmode}
            code={code}
            title={`${action} ${stitle}`}
            service={service}
            action={action} 
            url={url}
            panels={panels}
            actionSet={actionSet}
            record={record}
            data={data}
            sdata={SData}
            sconfig={ServiceConfig}
            formatters={_formformatters}
            onChange={onChange}
            onSubmit={onSubmit}
            onResponse={this.onResponse}
            onClose={this.onClose.bind(this)}
            showNotification={showNotification}
            swidth={"md"}
            {...others}
          />
        )}
        {loading && (
          <ProgressDialog
            open={loading}
            loading={loading}
            startLoading={this.startLoading}
            stopLoading={this.stopLoading}
          />
        )}
        {(!open) && (
          <MainPanel 
            navigate={this.onNavigate}
            title={stitle}
            sconfig={ServiceConfig}
            sdata={SData}
            rows={cm}
            data={data}
            actionSet={actionSet}
            {...others}
          />
        )}
      </Box>
    );
  };
}

export default DirectBudget;
